import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';
import authSelectors from 'redux/auth/authSelectors';

import { setFromRefcode } from 'redux/auth/authSlice';

import appOperations from 'redux/app/appOperations';
import userOperations from 'redux/user/userOperations';
import partnersOperations from 'redux/partners/partnersOperations';

import useWindowSize from 'hooks/useWindowSize';
import useBlockScroll from 'hooks/useBlockScroll';
import useTheme from 'hooks/useTheme';
import useTranslation from 'hooks/useTranslation';

import Router from 'router';

function App() {
  const dispatch = useDispatch();

  const lang = useSelector(appSelectors.language);
  const isAuthorized = useSelector(authSelectors.isAuthorized);

  const [searchParams] = useSearchParams();
  const fromRefcode = searchParams.get('ref');

  useEffect(() => {
    if (fromRefcode) {
      dispatch(partnersOperations.sendClick({ referral_code: fromRefcode }));
      dispatch(setFromRefcode(fromRefcode));
    }
  }, [dispatch, fromRefcode]);

  useEffect(() => {
    if (isAuthorized && lang) appOperations.setLanguage(lang.toUpperCase());
  }, [isAuthorized, lang]);

  useEffect(() => {
    if (isAuthorized) dispatch(appOperations.getAlert());
  }, [dispatch, isAuthorized]);

  useEffect(() => {
    if (isAuthorized) dispatch(userOperations.getUser());
  }, [dispatch, isAuthorized]);

  useEffect(() => {
    if (isAuthorized) dispatch(appOperations.getAvailablePages());
  }, [dispatch, isAuthorized]);

  useWindowSize();
  useBlockScroll();
  useTheme();
  useTranslation();

  return <Router />;
}

export default App;
